export default __webpack_public_path__ + "static/media/email.ba8240e3.webp";